import override_statusHtml from './override-status.html?raw';

export const template = override_statusHtml;

/** Shared `.ds-status-pill` tones used by override status (membership / permissions). */
export type TOverrideStatusPillVariant = 'success' | 'danger' | 'info' | 'warning' | 'muted';

export interface IOverrideStatusParams {
    translationKey: string;
    pillVariant: TOverrideStatusPillVariant;
    /**
     * Kept for call-site compatibility; comment presence is shown via
     * `.ds-inline-note` in the expanded override panel, not on the pill.
     */
    hasComment?: boolean | KnockoutObservable<boolean>;
}

/** Shared override status pill (group members, user membership, permissions). */
export class viewModel {
    readonly translationKey: string;
    readonly pillCls: string;

    constructor(params: IOverrideStatusParams) {
        this.translationKey = params.translationKey;
        this.pillCls = `ds-status-pill--${params.pillVariant}`;
    }
}
